import type { Entries } from './catalog';

/**
 * The copy of where a person is going and how they get on from where they are: what signing in leads to
 * and why it is asked again (settled contract S06), a destination that is ignored and said so, and the
 * way on from a screen that cannot show what was asked for (decision D06).
 */
export const journeys: Record<'en' | 'es', Entries> = {
	en: {
		'signin.continue': 'After signing in, you will continue where you were going.',
		'signin.invitation': 'After signing in, you can accept the invitation.',
		'signin.ignored': 'The return address is not allowed. You will stay here after signing in.',
		'overview.ignored': 'The return address is not allowed, so you stayed here.',
		'organization.closed.action': 'Your organizations',
		'invitation.onward': 'Go to your overview',
		'invitation.signin.other': 'Sign out and sign in with the invited address',
		'notfound.action': 'Go to your overview',
		'leave.ignored': 'The product did not register this return address. Open the product from its own address.'
	},
	es: {
		'signin.continue': 'Después de iniciar sesión, seguirás adonde ibas.',
		'signin.invitation': 'Después de iniciar sesión, podrás aceptar la invitación.',
		'signin.ignored': 'La dirección de vuelta no está permitida. Te quedarás aquí después de iniciar sesión.',
		'overview.ignored': 'La dirección de vuelta no está permitida, así que sigues aquí.',
		'organization.closed.action': 'Tus organizaciones',
		'invitation.onward': 'Ir a tu resumen',
		'invitation.signin.other': 'Cerrar sesión e iniciarla con la dirección invitada',
		'notfound.action': 'Ir a tu resumen',
		'leave.ignored': 'El producto no registró esta dirección de vuelta. Abre el producto desde su propia dirección.'
	}
};
